
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-[#0A1F1F] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=abstract%20minimalist%20artificial%20intelligence%20and%20data%20technology%20background%20with%20neural%20network%20patterns%20and%20flowing%20data%20streams%2C%20deep%20teal%20and%20dark%20cyan%20tones%20with%20touches%20of%20bright%20turquoise%20accents%2C%20professional%20corporate%20atmosphere%20representing%20AI%20research%20and%20development%2C%20clean%20modern%20design%20with%20geometric%20elements%20and%20subtle%20grid%20overlay%2C%20soft%20ambient%20lighting%20creating%20sophisticated%20technical%20mood%2C%20futuristic%20data%20science%20aesthetic%20with%20depth%20and%20dimension&width=1920&height=1080&seq=hero-ai-data-bg-001&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F1F]/60 via-[#0A1F1F]/40 to-[#0A1F1F]/60"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
        <div className="max-w-4xl">
          <div className="inline-flex items-center px-4 py-2 rounded-full border border-[#14B8A6]/30 bg-[#14B8A6]/5 mb-8">
            <span className="text-xs font-light text-[#5EEAD4] tracking-wide">AI · Data · R&D</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6" style={{ letterSpacing: '-0.02em' }}>
            AI와 데이터로<br />
            연구와 현장을 연결합니다
          </h1>

          <p className="text-xl md:text-2xl text-[#5EEAD4] mb-4 font-medium">
            공공·기업 R&D 과제부터 실증 사업까지<br />
            <span className="font-bold">AI·데이터 기반 문제 해결 파트너</span>
          </p>

          <p className="text-base md:text-lg text-gray-300 mb-12 max-w-2xl leading-relaxed">
            4-lab은 인공지능과 데이터 기술을 바탕으로<br />
            공공·기업의 연구개발과 실증 프로젝트를 수행하며,<br />
            현장에서 실제로 작동하는 해결책을 만듭니다.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-8 h-12 bg-[#14B8A6] text-white rounded-full font-medium text-sm hover:bg-[#0D9488] transition-colors cursor-pointer whitespace-nowrap"
            >
              프로젝트 문의하기
            </Link>
            <Link
              to="/projects"
              className="inline-flex items-center justify-center px-8 h-12 bg-transparent text-white border border-[#14B8A6] rounded-full font-medium text-sm hover:bg-[#14B8A6]/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              수행 프로젝트 보기
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-xl text-[#5EEAD4]"></i>
      </div>
    </section>
  );
}
